import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MovieInfo from './MovieInfo';

ReactDOM.render(<MovieInfo />, document.getElementById('root'));